import React, { useState, useEffect } from "react";
import { Button, Select } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faCircle } from "@fortawesome/free-solid-svg-icons";

import useMembersStore from "../../store/members.store";
import "./filter.scss"; 
import useSettingstore from "../../store/settings.store";
import { getFieldStyle } from "../../themes";
import { FILTER_DURATION_OPTIONS } from "../../helper/categoryconstants";

function Filter({
  filtername,
  handleFilter,
  enableDuration = false,
  enableResumes = false,
  enablePriority = false,
  enableJdStatus = false,
  enableCustomers = false,
  disableCustomersOptionAll = false,
  disableCustomersOptionInternal =false,
  enableTAs = false,
  initDuration,
  initPrio,
  initResume,
  initJDStatus,
  initClient,
  pageNo,
  pageSize,
  pageHandler = null,
  nujobsPost = false
}) {
  const [filterAppNum, setAppNum] = useState(initResume);// all
  const [filterDuration, setDuration] = useState(initDuration);
  const [filterParamPrio, setFilterPrio] = useState(initPrio); //all
  const [filterParamJobStatus, setFilterJobStatus] = useState(initJDStatus);//"Active"
  const [filterParamClient, setFilterClient] = useState(initClient);
  const [filterParamTA, setFilterTA] = useState("All");

  const { getClients, clients ,clientsFlag,resetClientsFlag,teamMembers} = useMembersStore();
  const { getSettingByKey, addOrUpdateSetting } = useSettingstore();

  const allOptions = { value: "All", label: "All" };
  const internalOptions = { value: "Internal", label: "Internal" };
  const [clientList, setClientList] = useState([]);
  const [clientListUpdated, setClientListUpdated] = useState(false);
  const [taList, setTAList] = useState([allOptions]);

  var clientInDB = clients?.map((client, idx) => {
    return {
      value: client?.ClientName,
      label: client?.ClientName,
    };
  });
  const createTAMappedList = (client) => {
    console.log("createTAMappedList", client)
    if(client == "Internal") {
      const tAData = teamMembers?.map((ta, idx) => {
            return {
                value:ta?.username,
                label:ta?.username,
            };
      });
      tAData?.push(allOptions);

      tAData != null ? setTAList([...tAData]) : setTAList([allOptions]);      
    }else{
      const tAData = client?.ClientTAList?.map((ta, idx) => {
            return {
                value:ta?.TAName,
                label:ta?.TAName,
            };
      });
      tAData?.push(allOptions);
      tAData != null ? setTAList([...tAData]) : setTAList([allOptions]); 
    }
  }

  const jdStatusListColored = [
    {
      value: "All",
      label: "All",
    },
    {
      value: "Active",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Active"),
              fontSize: "10px",
            }}
          />{" "}
          Active
        </span>
      ),
    },
    {
      value: "Closed",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Closed"),
              fontSize: "10px",
            }}
          />{" "}
          Closed
        </span>
      ),
    },
    {
      value: "Hold Pipeline",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Hold Pipeline"),
              fontSize: "10px",
            }}
          />{" "}
          Hold Pipeline
        </span>
      ),
    },
    {
      value: "Hold Selection",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Hold Selection"),
              fontSize: "10px",
            }}
          />{" "}
          Hold Selection
        </span>
      ),
    },
    {
      value: "Hold FB Pending",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Hold-FB Pending"),
              fontSize: "10px",
            }}
          />{" "}
          Hold-FB Pending
        </span>
      ),
    },
    {
      value: "Expired",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdStatusDot", "Expired"),
              fontSize: "10px",
            }}
          />{" "}
          Expired
        </span>
      ),
    },    
  ];

  const jdStatusList = [
    {
      value: "All",
      label: "All",
    },
    {
      value: "Active",
      label: "Active",
    },
    {
      value: "Closed",
      label: "Closed",
    },
    {
      value: "Hold Pipeline",
      label: "Hold Pipeline",
    },
    {
      value: "Hold Selection",
      label: "Hold Selection",
    },
    {
      value: "Hold FB Pending",
      label: "Hold FB Pending",
    },
  ];

  const jdPriorityListColored = [
    { value: "All", label: "All" },
    {
      value: "High",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "High"),
              fontSize: "10px",
            }}
          />{" "}
          High
        </span>
      ),
    },
    {
      value: "Urgent",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Urgent"),
              fontSize: "10px",
            }}
          />{" "}
          Urgent
        </span>
      ),
    },
    {
      value: "Todays",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Todays"),
              fontSize: "10px",
            }}
          />{" "}
          Todays
        </span>
      ),
    },
    {
      value: "Low",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Low"),
              fontSize: "10px",
            }}
          />{" "}
          Low
        </span>
      ),
    },
    {
      value: "Normal",
      label: (
        <span>
          {" "}
          <FontAwesomeIcon
            icon={faCircle}
            style={{
              ...getFieldStyle("jdPriorityDot", "Normal"),
              fontSize: "10px",
            }}
          />{" "}
          Normal
        </span>
      ),
    },
  ];

  const jdPriorityList = [
    { value: "All", label: "All" },
    {
      value: "High",
      label: "High",
    },
    {
      value: "Urgent",
      label: "Urgent",
    },
    {
      value: "Todays",
      label: "Todays",
    },
    {
      value: "Low",
      label: "Low",
    },
    {
      value: "Normal",
      label: "Normal",
    },
  ];

  const initFilterfromStore = () => {
      var filterObj = getSettingByKey(filtername)
      //console.log("filterObj",filterObj)
      if( filterObj != null){
       if(filterObj.value.appnum != undefined) 
       setAppNum(filterObj.value.appnum)

       if(filterObj.value.filterDuration != undefined) 
       setDuration(filterObj.value.filterDuration)

       if(filterObj.value.prio != undefined) 
       setFilterPrio(filterObj.value.prio)

       if(filterObj.value.jobstatus != undefined) 
       setFilterJobStatus(filterObj.value.jobstatus)

       if(filterObj.value.client != undefined) 
       setFilterClient(filterObj.value.client)

       if(filterObj.value.ta != undefined) 
       setFilterTA(filterObj.value.ta)
      }
  };

  const getDataforFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues.prio = filterParamPrio;
    encodedJsonValues.jobstatus = filterParamJobStatus;
    encodedJsonValues.client = filterParamClient;
    encodedJsonValues.ta = filterParamTA;
    encodedJsonValues.appnum = filterAppNum;
    encodedJsonValues.pagenum = pageNo;
    encodedJsonValues.pagesize = pageSize;
    encodedJsonValues.nujobsPost = nujobsPost
    //console.log("In getDataforFilter", filtername, filterDuration, encodedJsonValues)
    
    if(handleFilter)handleFilter(filterDuration, encodedJsonValues);
  };

   const handleUpdateFilter = () => {
    let encodedJsonValues = {};
    encodedJsonValues.prio = filterParamPrio;
    encodedJsonValues.jobstatus = filterParamJobStatus;
    encodedJsonValues.client = filterParamClient;
    encodedJsonValues.ta = filterParamTA;
    encodedJsonValues.appnum = filterAppNum;
    encodedJsonValues.pagenum = 1;
    encodedJsonValues.pagesize = pageSize;
    encodedJsonValues.nujobsPost = nujobsPost

    if (pageHandler) pageHandler(1)

    console.log("In handleUpdateFilter", filtername, filterDuration, encodedJsonValues)
    if(handleFilter) handleFilter(filterDuration, encodedJsonValues);

    //update store
    encodedJsonValues.filterDuration = filterDuration;
    let filterSettings = {"key":filtername, "value":encodedJsonValues}
    addOrUpdateSetting(filterSettings)
  };

 useEffect(() => {
    // Call API whenever page or pageSize changes
    if(clientListUpdated){    
      getDataforFilter();
    }
  }, [pageNo, pageSize, clientListUpdated]);

  useEffect(() => {
    initFilterfromStore()
    getClients();
  }, []);
  
  
  useEffect(() => {
    if(clientsFlag){
      if(!disableCustomersOptionAll){
        clientInDB = clients?.map((client, idx) => {
          return {
            value: client?.ClientName,
            label: client?.ClientName,
          };
        });      
      }else{
        clientInDB =[] // no clients need for internal
      }

      if(!disableCustomersOptionInternal){
        clientInDB?.push(internalOptions);
      }      
      if(!disableCustomersOptionAll){
        clientInDB?.push(allOptions);
      }else{
        //only internal is allowed
        createTAMappedList("Internal")
      }      
      clientInDB != null ? setClientList([...clientInDB]) : setClientList();
      setClientListUpdated(true);
      resetClientsFlag()
    }
  }, [clientsFlag]);

  const handleDuration = (value) => {
    setDuration(value);
  };
  const handleNumberApplications = (value) => {
    setAppNum(value);
  };
  const handleFilterJDPriority = (value) => {
    setFilterPrio(value);
  };
  const handleFilterJDstatus = (value) => {
    setFilterJobStatus(value);
  };

  const handleFilterCustomers = (value) => {

      setFilterClient(value);

      // 🔥 RESET TA FIRST
      setFilterTA("All");
    
      if(value == "Internal") {
        createTAMappedList("Internal")
      }else{
        var myClient = clients.filter((item)=> item?.ClientName===value)
        createTAMappedList(...myClient)
      }

    
  };

  const handleFilterTA = (value) => {
    setFilterTA(value);
  };
  return (
    <>
      <div className="generic-filter">
        <div className="teamTask-filter-item-wrapper">
          <div className="teamTask-filter-item-label"></div>
          {(enableTAs || enableDuration || enableResumes || enablePriority || enableJdStatus || enableCustomers) && (
            <div className="teamTask-filter-item" style={{ margin: "10px" }}>
              <Button onClick={handleUpdateFilter}>Update Now</Button>
            </div>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableTAs &&  (
            <>
              <div className="teamTask-filter-item-label">TA</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleFilterTA}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterParamTA}
                  options={taList}
                />
              </div>
            </>
          )}
        </div>         
        <div className="teamTask-filter-item-wrapper">
          {enableCustomers && (
            <>
              <div className="teamTask-filter-item-label">Clients</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24, textAlign: "left" }}
                  onChange={handleFilterCustomers}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterParamClient}
                  options={clientList}
                />
              </div>
            </>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableJdStatus && (
            <>
              <div className="teamTask-filter-item-label">JD Status</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleFilterJDstatus}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterParamJobStatus}
                  options={jdStatusListColored}
                />
              </div>
            </>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enablePriority && (
            <>
              <div className="teamTask-filter-item-label">Priority</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleFilterJDPriority}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  value={filterParamPrio}
                  options={
                    filtername == "getAllJdsInternalConsolidatedStats"
                      ? jdPriorityListColored
                      : jdPriorityList
                  }
                />
              </div>
            </>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableResumes && (
            <>
              <div className="teamTask-filter-item-label">Resumes</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleNumberApplications}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterAppNum}
                  options={[
                    { value: "All", label: "All" },
                    { value: "Present", label: "> 0" },
                    { value: "Not Present", label: " = 0" },
                  ]}
                />
              </div>
            </>
          )}
        </div>
        <div className="teamTask-filter-item-wrapper">
          {enableDuration && (
            <>
              <div className="teamTask-filter-item-label">Duration</div>
              <div className="teamTask-filter-item">
                <Select
                  style={{ width: 130, height: 24 }}
                  onChange={handleDuration}
                  showSearch={true}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  value={filterDuration}
                  options={FILTER_DURATION_OPTIONS}                 
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default Filter;
